import { type ComponentPropsWithoutRef, type ReactNode, type Ref } from 'react';
import classNames from 'classnames';
import FormError from '@/components/FormError';
import IcChevronDown from '@/assets/icons/ChevronDown.svg?react';
import styles from './FormSelect.module.scss';

type FormInputProps = Omit<ComponentPropsWithoutRef<'select'>, 'className'> & {
  className?: {
    label?: string;
    select?: string;
  };
  errorMessage?: string;
  id: string;
  label: string;
  children: ReactNode | ReactNode[];
  ref?: Ref<HTMLSelectElement>;
};

const FormSelect = ({
  autoComplete = 'off',
  className,
  errorMessage,
  id,
  label,
  children,
  ref,
  ...rest
}: FormInputProps) => {
  return (
    <>
      <label
        htmlFor={id}
        className={classNames(styles.label, className?.label)}
      >
        {label}
      </label>
      <div
        className={classNames(styles.selectWrapper, className?.select, {
          [styles.hasError]: !!errorMessage,
        })}
      >
        <select
          {...rest}
          autoComplete={autoComplete}
          ref={ref}
          className={styles.select}
          id={id}
        >
          {children}
        </select>
        <div className={styles.indicator}>
          <IcChevronDown className={styles.icon} />
        </div>
      </div>
      {errorMessage && <FormError message={errorMessage} />}
    </>
  );
};

export default FormSelect;
